import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { UzurvPipesModule } from '@uzurv/core';
import { PromptDialogComponent } from './prompt-dialog.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, MatInputModule, MatDialogModule, MatButtonModule, UzurvPipesModule],
  exports: [PromptDialogComponent],
  declarations: [PromptDialogComponent]
})
export class PromptDialogModule {}
